<template>
  <div>
    <Head title="Create User" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-gray-400 hover:text-gray-600" href="/users">{{$t('users.users')}}</Link>
      <span class="text-gray-400 font-medium">/ </span> {{$t('users.new')}}
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.first_name" :error="form.errors.first_name" class="pb-8 pr-6 w-full lg:w-1/2" :label="$t('users.first_name')" :disabled="isVolunteer" :required="true" />
          <text-input v-model="form.last_name" :error="form.errors.last_name" class="pb-8 pr-6 w-full lg:w-1/2" :label="$t('users.last_name')" :disabled="isVolunteer" :required="true" />
          <text-input v-model="form.email" :error="form.errors.email" class="pb-8 pr-6 w-full lg:w-1/2" :label="$t('users.email')" :required="true"  />
          <password-input v-model="form.password" :error="form.errors.password" class="pb-8 pr-6 w-full lg:w-1/2" :label="$t('users.password')" :hint="$t('password.hint')" autocomplete="new-password" :required="true" />
          <div class="pr-6 pb-8 w-full lg:w-1/2">
            <select-language v-model="form.language" :error="form.errors.language" :label="$t('users.language')" :required="true"  />
            <p class="text-gray-400 text-xs pt-1">{{ $t('users.hints.language') }}</p>
          </div>
          <select-multiple v-if="!isVolunteer" :default-options="roles.permissions" v-model="form.permissions" :error="form.errors.permissions"
                           class="pb-8 pr-6 w-full lg:w-1/2" :label="$t('users.permissions')"
          />
          <text-input v-if="!isVolunteer" type="date" v-model="form.authorization_date" :error="form.errors.authorization_date" class="pb-8 pr-6 w-full lg:w-1/2" :label="$t('users.authorization_date')" />
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">{{$t('global.create')}}</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import selectMultiple from '@/Shared/SelectMultiple'
import SelectLanguage from '@/Shared/SelectLanguage'
import PasswordInput from '@/Shared/PasswordInput'

export default {
  components: {
    FileInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    selectMultiple,
    SelectLanguage,
    PasswordInput
  },
  layout: Layout,
  props: {
    data: Object,
    roles: Object,
  },
  remember: 'form',
  computed: {
    isVolunteer(){
      return !!(this.form.volunteer_id)
    },
  },
  mounted() {
    if (this.data) {
      this.form.first_name = this.data.first_name
      this.form.last_name = this.data.last_name
      this.form.volunteer_id = this.data.id
    }

  },
  data() {
    return {
      form: this.$inertia.form({
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        permissions: null,
        language: null,
        authorization_date: null,
        volunteer_id: null
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/users')
    },
  },
}
</script>
